import { useEffect, useState } from "react";
import { WtButton } from "../../../shared/widges/Button/button";
import _ from "lodash";
import styles from "./incomingChat.module.scss";
import { useDispatcher } from "../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getNecessaryDetailswithsession } from "../../../store/api/helperspi/contactListapiService";
import { ChatActions } from "../../../store/slices/chat_slice/chat_slice";
import { SocialmediaWidgetActions } from "../../../store/slices/socialmediaWidget";
import callChatService from "../../../base/service/chatService";
import { GetItemFromStorage } from "../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../custom_hooks/localStorageKeys";
import { CoreServices } from "../../../base/service/apiServices";
import { notification } from "antd";
import moment from "moment";
import { getPriviousChannelSummary } from "../utils";

function IncomingSocialmediaNotify() {
  const navigate = useNavigate();
  const dispatch = useDispatcher();
  const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
  const LoginUserDetails: any = userDetails;
  const [over, setOver] = useState(false);
  const [[m, s], setTime] = useState<any>([0, 30]);
  const socialmediaWidget: any = useSelector((state: any) => state.socialmediaWidget);
  const { inviteData, } = socialmediaWidget
  const [agentOccupyDetails, setAgentOccupyDetails] = useState(null);
  const [disableAcceptChat, setDisableAcceptChat] = useState<boolean>(false);

  const declineNotify = () => {
    const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
    dispatch(SocialmediaWidgetActions.setSocialmediaInvite(false));
    const ringer: any = document.getElementById("ringer");
    if (ringer) ringer.pause();
    if (inviteData?.isTransferChat !== 0) {
      callChatService.io.emit("socialMediaAgentDeclineRequest", {
        sessionId: inviteData?.sessionId,
        channelType: inviteData?.channelType,
        responseMessage: "agent is declined",
        userId: LoginCcaasUserDetails.UserID,
        ext: LoginCcaasUserDetails.ext,
        domainId: LoginCcaasUserDetails.domainId,
        UserName: LoginCcaasUserDetails.UserName,
        customerNumber: inviteData?.customerNumber,
        agentNumber: inviteData?.agentNumber,
        calledPersonDetails: inviteData?.calledPersonDetails,
        historyId: inviteData?.historyId,
        allAgent: inviteData?.allAgent,
        WhatsappDurationHistoryId: inviteData?.WhatsappDurationHistoryId ?? null,
        isTransferChat: inviteData.isTransferChat,
        currentNode: inviteData?.currentNode
      });
       callChatService.io.emit('socialMediaDeclinedDeviceType', {
            ChatHistoryId:  inviteData?.WhatsappDurationHistoryId ?? null,
            to: `${LoginCcaasUserDetails.domainId}_${LoginCcaasUserDetails.ext}`,
            agentId: LoginCcaasUserDetails.UserID,
            deviceType: 'Web',
            // isTransfer: roomData?.internalSessionDetailswhilePopup.transferType == 1 ? 1 : 0
          });
    }

    if (inviteData?.isTransferChat !== 0) {
      if (inviteData?.channelType === 'Whatsapp') {
        callChatService.agentMissedCallWhatsapp({
          message: "Agent declined/missed the activity",
          sessionId: inviteData?.sessionId,
          channelType: inviteData?.channelType,
          agentExt: LoginUserDetails?.ext,
          agentName: LoginUserDetails?.profileName,
          domainId: LoginUserDetails?.domainId,
          AgentId: LoginCcaasUserDetails?.UserID,
          WhatsappHistoryId: inviteData?.historyId,
          WhatsappDurationHistoryId: inviteData?.WhatsappDurationHistoryId ?? null,
          customerNumber: inviteData?.customerNumber,
          agentNumber: inviteData?.agentNumber,
          IsMissed: 1
        })
      } else if (inviteData?.channelType === 'Facebook') {
        callChatService.agentMissedCallFacebook({
          message: "Agent declined/missed the activity",
          sessionId: inviteData?.sessionId,
          channelType: inviteData?.channelType,
          agentExt: LoginUserDetails?.ext,
          agentName: LoginUserDetails?.profileName,
          domainId: LoginUserDetails?.domainId,
          AgentId: LoginCcaasUserDetails?.UserID,
          FacebookHistoryId: inviteData?.historyId,
          customerNumber: inviteData?.customerNumber,
          agentNumber: inviteData?.agentNumber,
          IsMissed: 1
        })
      } else {
        callChatService.agentMissedCallInstagram({
          message: "Agent declined/missed the activity",
          sessionId: inviteData?.sessionId,
          channelType: inviteData?.channelType,
          agentExt: LoginUserDetails?.ext,
          agentName: LoginUserDetails?.profileName,
          domainId: LoginUserDetails?.domainId,
          AgentId: LoginCcaasUserDetails?.UserID,
          FacebookHistoryId: inviteData?.historyId,
          customerNumber: inviteData?.customerNumber,
          agentNumber: inviteData?.agentNumber,
          IsMissed: 1
        })
      }
      dispatch(SocialmediaWidgetActions.setInviteData({}));
    }
  }

  const tick = () => {
    const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
    console.log('agentDeclineRequest tick function',m,s);

    if (m === 0 && s === 0) {

      callChatService.io.emit('socialMediaDeclinedDeviceType', {
        ChatHistoryId: inviteData?.WhatsappDurationHistoryId ?? null,
        to: `${LoginUserDetails?.domainId}_${LoginUserDetails?.ext}`,
        agentId: LoginCcaasUserDetails?.UserID,
        deviceType: 'Web',
        // isTransfer: roomData?.internalSessionDetailswhilePopup.transferType == 1 ? 1 : 0
      });
      dispatch(SocialmediaWidgetActions.setSocialmediaInvite(false));
      const ringer: any = document.getElementById("ringer");
      if (ringer) ringer.pause();
      clearInterval(timerID);
      declineNotify();
      setOver(true);
    } else {
        setTime([m, s - 1]);
      
    }
  };

  let timerID: any = null;
  useEffect(() => {
    timerID = setInterval(() => tick(), 1000);
    return () => {
      clearInterval(timerID);
    };
  }, [m, s]);

  useEffect(() => {
    const ringer: any = document.getElementById("ringer");
    if (ringer) {
      const playPromise = ringer.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          console.warn("Autoplay failed");
        });
      }
    }
  }, []);

  useEffect(() => {
    CoreServices.get(`/get_concurrent_chat`).then((value: any) => {
      if (value?.data?.statusCode === 200) {
        const tempData = value?.data?.getConcurrentChatDataRes[0]?.agentOccupyDetails;
        setAgentOccupyDetails(JSON.parse(tempData));
      } else {
        notification.error({
          message: value?.data?.message || 'Unable to fetch Value',
          placement: "topRight",
          duration: 7,
          top: 70,
        });
      }
    });
  }, []);

  const goToWorkspace = async (e: any, index: any, value: any) => {
    setDisableAcceptChat(true);
    let contact = inviteData?.customerNumber
    const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);

    try {
      const res: any = await dispatch(getNecessaryDetailswithsession({ contact, sessionId: inviteData?.sessionId.trim(), channelType: inviteData?.channelType })).unwrap();
      if (res.sessionDetail?.data.statusCode === 200) {
        const ringer: any = document.getElementById("ringer");
        if (ringer) ringer.pause();
        let chatSessionData: any = res?.sessionDetail?.data?.getEmailListRes[0];
        chatSessionData.Number = value?.customerNumber;
        chatSessionData.showState = true;
        chatSessionData.queueName = ''
        chatSessionData.ChatHistoryId = ''
        chatSessionData.currentSessionMsgHistory = []
        chatSessionData.dialDuration = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        if (res.contact?.data.statusCode === 200) {
          chatSessionData.calledPersonDetails = res.contact?.data?.getContactNumberRes[0] || res.contact?.data?.getContactDetailsRes?.[0];
          try {
            const coid = res.contact?.data?.getContactNumberRes?.[0]?.coid || res.contact?.data?.getContactDetailsRes?.[0]?.coid
            getPriviousChannelSummary(dispatch, { coid, currentSessionId: inviteData?.sessionId?.trim() })
          } catch (error) {
            console.log("getPriviousChannelSummary", error)
          }
        } else {
          chatSessionData.calledPersonDetails = {};
        }
        let removeUserPayload = {
          sessionId: chatSessionData?.sessionId.trim(),
          historyId: chatSessionData?.channelType === 'Whatsapp' ? chatSessionData?.WhatsappHistoryId : chatSessionData?.channelType === 'Facebook' ? chatSessionData.FacebookHistoryId : chatSessionData?.channelType === 'Instagram' ? chatSessionData.InstagramHistoryId : '',
          removeQueueId: inviteData?.currentNode,
          domainId: LoginUserDetails?.domainId,
          channelType: chatSessionData?.channelType,
        }
        callChatService.removeChatQueueUserSocialmedia(removeUserPayload);
        callChatService.io.emit("socialMediaAgentAssistDetails", {
          message: chatSessionData?.Message ?? '',
          sessionId: chatSessionData?.sessionId,
          channelType: chatSessionData?.channelType,
          agentExt: LoginUserDetails?.ext,
          domainId: LoginUserDetails?.domainId,
          historyId: chatSessionData?.channelType === 'Whatsapp' ? chatSessionData?.WhatsappHistoryId : chatSessionData?.channelType === 'Facebook' ? chatSessionData.FacebookHistoryId : chatSessionData?.channelType === 'Instagram' ? chatSessionData.InstagramHistoryId : '',
          customerNumber: inviteData?.customerNumber,
          agentNumber: inviteData?.agentNumber,
        });
        callChatService.io.emit("socialMediaAgentAcceptRequest", {
          message: "Agent accept the activity",
          sessionId: chatSessionData?.sessionId,
          channelType: chatSessionData?.channelType,
          agentExt: LoginUserDetails?.ext,
          agentName: LoginUserDetails?.profileName,
          domainId: LoginUserDetails?.domainId,
          agentId: LoginCcaasUserDetails?.UserID,
          historyId: chatSessionData?.channelType === 'Whatsapp' ? chatSessionData?.WhatsappHistoryId : chatSessionData?.channelType === 'Facebook' ? chatSessionData.FacebookHistoryId : chatSessionData?.channelType === 'Instagram' ? chatSessionData.InstagramHistoryId : '',
          customerNumber: inviteData?.customerNumber,
          agentNumber: inviteData?.agentNumber,
          dialDuration: 31 - s,
          IsMissed: 0
        });
        callChatService.io.emit('socialMediaDeclinedDeviceType', {
          ChatHistoryId: inviteData?.WhatsappDurationHistoryId ?? null,
          to: `${LoginUserDetails?.domainId}_${LoginUserDetails?.ext}`,
          agentId: LoginCcaasUserDetails?.UserID,
          deviceType: 'Web',
          // isTransfer: roomData?.internalSessionDetailswhilePopup.transferType == 1 ? 1 : 0
        });
        dispatch(SocialmediaWidgetActions.setSocialmediaInvite(false));
        dispatch(SocialmediaWidgetActions.setInviteData({}));
        dispatch(ChatActions.chatSessionList(chatSessionData));
        dispatch(ChatActions.currentChatSession(chatSessionData));
        navigate("/chatscreenagent");
        let values: any;
        if (agentOccupyDetails === null) {
          values = {
            "agentOccupyDetails": JSON.stringify({
              currentChatCount: { [LoginUserDetails?.ext]: 1 }
            })
          };
        } else {
          const tempData: any = agentOccupyDetails;
          const existingCurrentChatCount = tempData["currentChatCount"][LoginUserDetails?.ext];
          tempData.currentChatCount = { ...tempData?.currentChatCount, [LoginUserDetails?.ext]: existingCurrentChatCount !== undefined ? existingCurrentChatCount + 1 : 1 };
          values = { "agentOccupyDetails": JSON.stringify(tempData) };
        }
        CoreServices.post(values, `/insert_update_concurrent_chat`).then((values: any) => {
          if (values?.data?.statusCode === 200) {
            console.log('success')
          } else {
            console.log('failed');
          }
        }).catch((error: any) =>
          console.log('insert_update_concurrent_chat error', error));
      }
    } catch (error) {
      console.log('Error during chat accept process:', error)
    } finally {
      setDisableAcceptChat(false);
    }

  };
  return (
    <>
      <div className={`${styles.callcontainartopsec}`}>
        <div className={`${styles.incomingTop} ${inviteData?.channelType === 'Whatsapp' ? styles.whatsapp : inviteData?.channelType === 'Facebook' ? styles.facebook : inviteData?.channelType === 'Instagram' ? styles.insta : ''}`}>
          {inviteData?.channelType === 'Whatsapp'
            ? <span className="icon__Whatsapp36"></span>
            : inviteData?.channelType === 'Facebook'
              ? <span className="icon__Fb36"></span>
              : inviteData?.channelType === 'Instagram'
                ? <span className="icon__Insta36"></span>
                : <span></span>}
          <span>Incoming Chat...</span>
        </div>
        <div className={styles.callwhisperinnercon}>
          <div className={styles.succesconsec}>
            {/* <div className={styles.userconsec}>
              <span>
                {inviteData?.calledPersonDetails && inviteData?.calledPersonDetails?.firstName?.trim()
                  ? `${inviteData.calledPersonDetails?.firstName} ${inviteData.calledPersonDetails?.lastName
                    && inviteData.calledPersonDetails?.lastName !== 'null' ? inviteData.calledPersonDetails?.lastName : ''}`
                  : "New customer"}
              </span>
              <label className={styles.phnenumber}>
                {inviteData?.channelType === 'Whatsapp' && '+'}{inviteData?.customerNumber}
              </label>
            </div> */}
            {inviteData.calledPersonDetails?.lastName?.length > 20 ?
              <div className={`${styles.userconsec} ${styles.widthfull}`}>
                <div className={"marqueeWrapper"}>
                  <span className="marqueeEffect">{inviteData?.calledPersonDetails && inviteData?.calledPersonDetails?.firstName?.trim()
                    ? `${inviteData.calledPersonDetails?.firstName} ${inviteData.calledPersonDetails?.lastName
                      && inviteData.calledPersonDetails?.lastName !== 'null' ? inviteData.calledPersonDetails?.lastName : ''}`
                    : "New customer"}</span>

                  <span className="marqueeEffect">{inviteData?.calledPersonDetails && inviteData?.calledPersonDetails?.firstName?.trim()
                    ? `${inviteData.calledPersonDetails?.firstName} ${inviteData.calledPersonDetails?.lastName
                      && inviteData.calledPersonDetails?.lastName !== 'null' ? inviteData.calledPersonDetails?.lastName : ''}`
                    : "New customer"}</span>
                </div>
                <label className={styles.phnenumber}>
                  {inviteData?.channelType === 'Whatsapp' && '+'}{inviteData?.customerNumber}
                </label>
              </div>
              :
              <div className={styles.userconsec}>
                <span>{inviteData?.calledPersonDetails && inviteData?.calledPersonDetails?.firstName?.trim()
                  ? `${inviteData.calledPersonDetails?.firstName} ${inviteData.calledPersonDetails?.lastName
                    && inviteData.calledPersonDetails?.lastName !== 'null' ? inviteData.calledPersonDetails?.lastName : ''}`
                  : "New customer"}</span>
                <label className={styles.phnenumber}>
                  {inviteData?.channelType === 'Whatsapp' && '+'}{inviteData?.customerNumber}
                </label>
              </div>
            }
            <div className={styles.supportconsec}>
              <label className={styles.anstxt}>
                Answer in{" "}
                <span className={styles.timecount}>
                  <p>{`${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`}</p>
                </span>
              </label>
            </div>
            <div className={styles.acceptbtnconsec}>
              <WtButton className={`buttonGreen ${styles.declinebtn}`} onClick={declineNotify} onTouchStart={declineNotify} name="Decline" />
              <WtButton className={`buttonGreen ${styles.acceptbtn}`} onClick={goToWorkspace} onTouchStart={goToWorkspace} disabled={disableAcceptChat} name="Accept" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default IncomingSocialmediaNotify;
